


/**
* Guide Stream Session Video Types
*/
export enum VideoType{
    /**
    * Full video containing all available client feed without redactions
    */
    Full = 0,
    /**
    * Type for when video parts are removed due to paused video
    */
    Redacted = 1
}

